/* AUTO-GERADO de scripts/build-data.py — metadados curados por produto.
   Preco/variante/availability vem do Shopify via Liquid. imgFile/galleryFiles
   sao nomes de assets do tema (fotos curadas); o bootstrap.js prefixa com SHOP.assets. */
window.THEME_META=[
 {
  "handle": "creme-barriga-fit-redutor",
  "slug": "creme-barriga-fit",
  "name": "Creme Barriga Fit®",
  "cat": "creme",
  "catLabel": "Creme redutor",
  "vol": "250 ml",
  "rating": "4.7",
  "badges": [],
  "bestseller": false,
  "bsRank": 99,
  "exp": false,
  "short": "Creme corporal de toque seco para a zona da barriga — massaje todos os dias para uma pele com aspecto mais firme, liso e cuidado.",
  "blurb": "Creme corporal para a barriga: textura sequinha e aspecto mais firme e liso.",
  "d2": null,
  "d3": null,
  "imgFile": "barriga-fit-creme.jpeg",
  "galleryFiles": [
   {
    "full": "barriga-fit-creme.jpeg",
    "thumb": "barriga-fit-creme.jpeg"
   },
   {
    "full": "g-creme-barriga-fit-01.jpg",
    "thumb": "g-creme-barriga-fit-01-t.jpg"
   },
   {
    "full": "g-creme-barriga-fit-02.jpg",
    "thumb": "g-creme-barriga-fit-02-t.jpg"
   },
   {
    "full": "g-creme-barriga-fit-03.jpg",
    "thumb": "g-creme-barriga-fit-03-t.jpg"
   },
   {
    "full": "g-creme-barriga-fit-04.jpg",
    "thumb": "g-creme-barriga-fit-04-t.jpg"
   },
   {
    "full": "g-creme-barriga-fit-05.jpg",
    "thumb": "g-creme-barriga-fit-05-t.jpg"
   },
   {
    "full": "g-creme-barriga-fit-06.jpg",
    "thumb": "g-creme-barriga-fit-06-t.jpg"
   }
  ]
 },
 {
  "handle": "body-cream-sublime-lush-com-oleo-de-sacha-inchi",
  "slug": "sublime-lush",
  "name": "Sublime Lush",
  "cat": "creme",
  "catLabel": "Body cream · Sacha Inchi",
  "vol": "250 ml",
  "rating": "5.0",
  "badges": [
   {
    "t": "Premium",
    "cls": ""
   }
  ],
  "bestseller": false,
  "bsRank": 99,
  "exp": false,
  "short": "Creme corporal premium com óleo amazónico de Sacha Inchi, rico em ómega — hidratação profunda e um toque sedoso e aveludado na pele.",
  "blurb": "Hidratação intensa com óleo de Sacha Inchi — pele macia, nutrida e aveludada.",
  "d2": null,
  "d3": null,
  "imgFile": "sublime-lush.jpg",
  "galleryFiles": [
   {
    "full": "sublime-lush.jpg",
    "thumb": "sublime-lush.jpg"
   },
   {
    "full": "g-sublime-lush-01.jpg",
    "thumb": "g-sublime-lush-01-t.jpg"
   },
   {
    "full": "g-sublime-lush-02.jpg",
    "thumb": "g-sublime-lush-02-t.jpg"
   },
   {
    "full": "g-sublime-lush-03.jpg",
    "thumb": "g-sublime-lush-03-t.jpg"
   },
   {
    "full": "g-sublime-lush-04.jpg",
    "thumb": "g-sublime-lush-04-t.jpg"
   },
   {
    "full": "g-sublime-lush-05.jpg",
    "thumb": "g-sublime-lush-05-t.jpg"
   },
   {
    "full": "g-sublime-lush-06.jpg",
    "thumb": "g-sublime-lush-06-t.jpg"
   }
  ]
 },
 {
  "handle": "gel-leg-fit-express-250-ml",
  "slug": "leg-fit-express",
  "name": "Gel Leg Fit Express®",
  "cat": "creme",
  "catLabel": "Gel · efeito frio",
  "vol": "250 ml",
  "rating": "4.8",
  "badges": [],
  "bestseller": false,
  "bsRank": 99,
  "exp": false,
  "short": "Gel de efeito frio para as pernas — alívio imediato e sensação de leveza ao fim do dia. Absorve depressa e não deixa a pele pegajosa.",
  "blurb": "Gel de efeito frio: leveza imediata e alívio para pernas cansadas.",
  "d2": null,
  "d3": null,
  "imgFile": "leg-fit-express-gel.jpeg",
  "galleryFiles": [
   {
    "full": "leg-fit-express-gel.jpeg",
    "thumb": "leg-fit-express-gel.jpeg"
   },
   {
    "full": "g-leg-fit-express-01.jpg",
    "thumb": "g-leg-fit-express-01-t.jpg"
   },
   {
    "full": "g-leg-fit-express-02.jpg",
    "thumb": "g-leg-fit-express-02-t.jpg"
   },
   {
    "full": "g-leg-fit-express-03.jpg",
    "thumb": "g-leg-fit-express-03-t.jpg"
   },
   {
    "full": "g-leg-fit-express-04.jpg",
    "thumb": "g-leg-fit-express-04-t.jpg"
   },
   {
    "full": "g-leg-fit-express-05.jpg",
    "thumb": "g-leg-fit-express-05-t.jpg"
   },
   {
    "full": "g-leg-fit-express-06.jpg",
    "thumb": "g-leg-fit-express-06-t.jpg"
   }
  ]
 },
 {
  "handle": "gel-levanta-bumbum-250-ml",
  "slug": "levanta-bumbum",
  "name": "Gel Levanta Bumbum®",
  "cat": "creme",
  "catLabel": "Gel · firmeza",
  "vol": "250 ml",
  "rating": "4.8",
  "badges": [],
  "bestseller": false,
  "bsRank": 99,
  "exp": false,
  "short": "Gel reafirmante para glúteos, coxas e abdómen — massaje diariamente para uma pele com aspecto mais firme, tonificado e uniforme.",
  "blurb": "Gel reafirmante para os glúteos — mais firmeza e pele uniforme.",
  "d2": null,
  "d3": null,
  "imgFile": "levanta-bumbum.jpeg",
  "galleryFiles": [
   {
    "full": "levanta-bumbum.jpeg",
    "thumb": "levanta-bumbum.jpeg"
   },
   {
    "full": "g-levanta-bumbum-01.jpg",
    "thumb": "g-levanta-bumbum-01-t.jpg"
   },
   {
    "full": "g-levanta-bumbum-02.jpg",
    "thumb": "g-levanta-bumbum-02-t.jpg"
   },
   {
    "full": "g-levanta-bumbum-03.jpg",
    "thumb": "g-levanta-bumbum-03-t.jpg"
   },
   {
    "full": "g-levanta-bumbum-04.jpg",
    "thumb": "g-levanta-bumbum-04-t.jpg"
   },
   {
    "full": "g-levanta-bumbum-05.jpg",
    "thumb": "g-levanta-bumbum-05-t.jpg"
   },
   {
    "full": "g-levanta-bumbum-06.jpg",
    "thumb": "g-levanta-bumbum-06-t.jpg"
   }
  ]
 },
 {
  "handle": "barriga-fit-stop-gordura",
  "slug": "stop-gordura",
  "name": "Barriga Fit® Stop Gordura",
  "cat": "capsula",
  "catLabel": "Cápsulas",
  "vol": "50 cápsulas",
  "rating": "4.7",
  "badges": [
   {
    "t": "Mais vendido",
    "cls": "best"
   }
  ],
  "bestseller": true,
  "bsRank": 3,
  "exp": false,
  "short": "As cápsulas mais vendidas da linha Barriga Fit — um apoio diário à sua rotina de controlo de peso e bem-estar, para se sentir mais leve.",
  "blurb": "Cápsulas para apoiar a sua rotina de controlo e bem-estar do dia a dia.",
  "d2": null,
  "d3": null,
  "imgFile": "barriga-fit-stop-gordura.jpeg",
  "galleryFiles": [
   {
    "full": "barriga-fit-stop-gordura.jpeg",
    "thumb": "barriga-fit-stop-gordura.jpeg"
   },
   {
    "full": "g-stop-gordura-01.jpg",
    "thumb": "g-stop-gordura-01-t.jpg"
   },
   {
    "full": "g-stop-gordura-02.jpg",
    "thumb": "g-stop-gordura-02-t.jpg"
   },
   {
    "full": "g-stop-gordura-03.jpg",
    "thumb": "g-stop-gordura-03-t.jpg"
   },
   {
    "full": "g-stop-gordura-04.jpg",
    "thumb": "g-stop-gordura-04-t.jpg"
   },
   {
    "full": "g-stop-gordura-05.jpg",
    "thumb": "g-stop-gordura-05-t.jpg"
   },
   {
    "full": "g-stop-gordura-06.jpg",
    "thumb": "g-stop-gordura-06-t.jpg"
   }
  ]
 },
 {
  "handle": "barriga-fit-detox-500ml",
  "slug": "detox-liquido",
  "name": "Barriga Fit® Detox",
  "cat": "capsula",
  "catLabel": "Detox líquido",
  "vol": "500 ml",
  "rating": "4.9",
  "badges": [
   {
    "t": "Mais vendido",
    "cls": "best"
   }
  ],
  "bestseller": true,
  "bsRank": 4,
  "exp": false,
  "short": "Detox líquido saboroso para tomar todos os dias — a sua rotina de leveza, com menos sensação de inchaço e mais bem-estar.",
  "blurb": "Detox líquido saboroso para uma rotina de leveza e menos sensação de inchaço.",
  "d2": null,
  "d3": null,
  "imgFile": "barriga-fit-detox.jpeg",
  "galleryFiles": [
   {
    "full": "barriga-fit-detox.jpeg",
    "thumb": "barriga-fit-detox.jpeg"
   },
   {
    "full": "g-detox-liquido-01.jpg",
    "thumb": "g-detox-liquido-01-t.jpg"
   },
   {
    "full": "g-detox-liquido-02.jpg",
    "thumb": "g-detox-liquido-02-t.jpg"
   },
   {
    "full": "g-detox-liquido-03.jpg",
    "thumb": "g-detox-liquido-03-t.jpg"
   },
   {
    "full": "g-detox-liquido-04.jpg",
    "thumb": "g-detox-liquido-04-t.jpg"
   },
   {
    "full": "g-detox-liquido-05.jpg",
    "thumb": "g-detox-liquido-05-t.jpg"
   },
   {
    "full": "g-detox-liquido-06.jpg",
    "thumb": "g-detox-liquido-06-t.jpg"
   }
  ]
 },
 {
  "handle": "leg-fit-pernas-leves",
  "slug": "pernas-leves",
  "name": "Leg Fit® Pernas Leves",
  "cat": "capsula",
  "catLabel": "Cápsulas · pernas",
  "vol": "60 cápsulas",
  "rating": "4.8",
  "badges": [],
  "bestseller": false,
  "bsRank": 99,
  "exp": false,
  "short": "Cápsulas pensadas para quem passa o dia em pé — um apoio diário à sensação de pernas leves e descansadas, sem aquele peso ao fim do dia.",
  "blurb": "Cápsulas para quem passa o dia em pé — apoio à sensação de pernas leves.",
  "d2": null,
  "d3": null,
  "imgFile": "leg-fit-pernas-leves.jpeg",
  "galleryFiles": [
   {
    "full": "leg-fit-pernas-leves.jpeg",
    "thumb": "leg-fit-pernas-leves.jpeg"
   }
  ]
 },
 {
  "handle": "barriga-fit-depur",
  "slug": "depur",
  "name": "Barriga Fit Depur",
  "cat": "capsula",
  "catLabel": "Detox fígado · ampolas",
  "vol": "15 ampolas",
  "rating": "4.8",
  "badges": [
   {
    "t": "Mais vendido",
    "cls": "best"
   }
  ],
  "bestseller": true,
  "bsRank": 5,
  "exp": false,
  "short": "Ampolas bebíveis para uma rotina detox de 15 dias — um cuidado depurativo de dentro para fora, a complementar a sua linha Barriga Fit.",
  "blurb": "Ampolas depurativas: um cuidado de dentro para fora na sua rotina detox.",
  "d2": null,
  "d3": null,
  "imgFile": "barriga-fit-depur.jpeg",
  "galleryFiles": [
   {
    "full": "barriga-fit-depur.jpeg",
    "thumb": "barriga-fit-depur.jpeg"
   },
   {
    "full": "g-depur-01.jpg",
    "thumb": "g-depur-01-t.jpg"
   },
   {
    "full": "g-depur-02.jpg",
    "thumb": "g-depur-02-t.jpg"
   },
   {
    "full": "g-depur-03.jpg",
    "thumb": "g-depur-03-t.jpg"
   },
   {
    "full": "g-depur-04.jpg",
    "thumb": "g-depur-04-t.jpg"
   },
   {
    "full": "g-depur-05.jpg",
    "thumb": "g-depur-05-t.jpg"
   },
   {
    "full": "g-depur-06.jpg",
    "thumb": "g-depur-06-t.jpg"
   }
  ]
 },
 {
  "handle": "kit-seca-barriga",
  "slug": "kit-seca-barriga",
  "name": "Kit Barriga Fit®",
  "cat": "kit",
  "catLabel": "Stop Gordura · Depur",
  "vol": "2 produtos",
  "rating": "4.9",
  "badges": [
   {
    "t": "Mais vendido",
    "cls": "best"
   }
  ],
  "bestseller": true,
  "bsRank": 2,
  "exp": false,
  "short": "O duo que cuida da barriga de dentro para fora: cápsulas Stop Gordura + detox hepático Depur — para a sensação de leveza e menos inchaço no dia a dia.",
  "blurb": "O duo da barriga: cápsulas Stop Gordura + ampolas Depur para mais leveza.",
  "d2": null,
  "d3": null,
  "imgFile": "kit-seca-barriga.jpg",
  "galleryFiles": [
   {
    "full": "kit-seca-barriga.jpg",
    "thumb": "kit-seca-barriga.jpg"
   },
   {
    "full": "g-kit-barriga-fit-01.svg",
    "thumb": "g-kit-barriga-fit-01.svg"
   },
   {
    "full": "g-kit-seca-barriga-02.jpg",
    "thumb": "g-kit-seca-barriga-02-t.jpg"
   },
   {
    "full": "g-kit-seca-barriga-03.jpg",
    "thumb": "g-kit-seca-barriga-03-t.jpg"
   },
   {
    "full": "g-kit-barriga-fit-04.svg",
    "thumb": "g-kit-barriga-fit-04.svg"
   },
   {
    "full": "g-kit-seca-barriga-05.jpg",
    "thumb": "g-kit-seca-barriga-05-t.jpg"
   },
   {
    "full": "g-kit-barriga-fit-06.svg",
    "thumb": "g-kit-barriga-fit-06.svg"
   }
  ]
 },
 {
  "handle": "kit-stop-gordura",
  "slug": "kit-stop-gordura",
  "name": "Kit Stop Gordura®",
  "cat": "kit",
  "catLabel": "Creme · Detox · Cápsulas",
  "vol": "3 produtos",
  "rating": "4.9",
  "badges": [
   {
    "t": "Top kit",
    "cls": "best"
   }
  ],
  "bestseller": false,
  "bsRank": 99,
  "exp": true,
  "short": "O trio completo Barriga Fit num só kit: creme redutor, detox líquido e cápsulas — a rotina inteira reunida, com mais vantagem no preço.",
  "blurb": "Trio Barriga Fit completo: creme, detox e cápsulas para uma rotina constante.",
  "d2": null,
  "d3": null,
  "imgFile": "kit-barriga-fit.jpeg",
  "galleryFiles": [
   {
    "full": "kit-barriga-fit.jpeg",
    "thumb": "kit-barriga-fit.jpeg"
   }
  ]
 },
 {
  "handle": "kit-detox-stop-desintoxica-queima-gordura-e-acelera-o-metabolismo-pack-stop-gordura-detox-liquido",
  "slug": "kit-detox-stop",
  "name": "Kit Detox + Stop Gordura",
  "cat": "kit",
  "catLabel": "Detox · Cápsulas",
  "vol": "2 produtos",
  "rating": "4.8",
  "badges": [
   {
    "t": "Mais vendido",
    "cls": "best"
   }
  ],
  "bestseller": true,
  "bsRank": 1,
  "exp": true,
  "short": "A nossa dupla mais vendida: detox líquido + cápsulas Stop Gordura — a combinação perfeita para começar a rotina com leveza e bem-estar.",
  "blurb": "A dupla mais vendida: detox líquido + cápsulas para começar com leveza.",
  "d2": null,
  "d3": null,
  "imgFile": "kit-detox-stop-gordura.jpg",
  "galleryFiles": [
   {
    "full": "kit-detox-stop-gordura.jpg",
    "thumb": "kit-detox-stop-gordura.jpg"
   },
   {
    "full": "g-kit-detox-stop-01.jpg",
    "thumb": "g-kit-detox-stop-01-t.jpg"
   },
   {
    "full": "g-kit-detox-stop-02.jpg",
    "thumb": "g-kit-detox-stop-02-t.jpg"
   }
  ]
 },
 {
  "handle": "kit-fire",
  "slug": "kit-fire",
  "name": "Kit Fire Emagrecimento®",
  "cat": "kit",
  "catLabel": "Depur · Stop Gordura · Drenagem",
  "vol": "3 produtos",
  "rating": "4.9",
  "badges": [
   {
    "t": "Intensivo",
    "cls": "best"
   }
  ],
  "bestseller": false,
  "bsRank": 99,
  "exp": true,
  "short": "O kit mais intensivo da linha: depur, cápsulas Stop Gordura e drenagem — três passos que se completam numa rotina de bem-estar mais focada.",
  "blurb": "Kit intensivo: depur, cápsulas e drenagem para uma rotina mais completa.",
  "d2": null,
  "d3": null,
  "imgFile": "kit-fire.jpeg",
  "galleryFiles": [
   {
    "full": "kit-fire.jpeg",
    "thumb": "kit-fire.jpeg"
   }
  ]
 },
 {
  "handle": "kit-stop-celulite-10-off",
  "slug": "kit-celulite-lipedema",
  "name": "Kit Stop Lipedema & Celulite",
  "cat": "kit",
  "catLabel": "Gel · Detox · Pernas Leves",
  "vol": "3 produtos",
  "rating": "4.7",
  "badges": [],
  "bestseller": false,
  "bsRank": 99,
  "exp": true,
  "short": "Rotina de cuidado para as pernas: gel reafirmante, detox e cápsulas Pernas Leves — por uma pele com aspecto mais liso e firme e mais leveza.",
  "blurb": "Foco em pernas e celulite: gel, detox e cápsulas para firmeza e leveza.",
  "d2": null,
  "d3": null,
  "imgFile": "kit-celulite-lipedema.jpeg",
  "galleryFiles": [
   {
    "full": "kit-celulite-lipedema.jpeg",
    "thumb": "kit-celulite-lipedema.jpeg"
   },
   {
    "full": "g-kit-celulite-lipedema-01.jpg",
    "thumb": "g-kit-celulite-lipedema-01-t.jpg"
   },
   {
    "full": "g-kit-celulite-lipedema-02.jpg",
    "thumb": "g-kit-celulite-lipedema-02-t.jpg"
   },
   {
    "full": "g-kit-celulite-lipedema-03.jpg",
    "thumb": "g-kit-celulite-lipedema-03-t.jpg"
   },
   {
    "full": "g-kit-celulite-lipedema-04.jpg",
    "thumb": "g-kit-celulite-lipedema-04-t.jpg"
   }
  ]
 },
 {
  "handle": "kit-verao®️-transformacao-completa-detox-queima-gordura-pernas-leves-e-firmeza-pack-4-produtos",
  "slug": "kit-verao",
  "name": "Kit Verão®",
  "cat": "kit",
  "catLabel": "Detox · Gordura · Pernas · Firmeza",
  "vol": "Pack 4 produtos",
  "rating": "4.9",
  "badges": [
   {
    "t": "Pack 4",
    "cls": "best"
   }
  ],
  "bestseller": false,
  "bsRank": 99,
  "exp": true,
  "short": "O pack 4 em 1 para chegar ao verão a sentir-se bem consigo: detox, controlo de gordura, pernas leves e firmeza, na rotina completa.",
  "blurb": "Pack de verão 4 em 1: detox, gordura, pernas leves e firmeza num só kit.",
  "d2": null,
  "d3": null,
  "imgFile": "kit-emagrecimento.jpeg",
  "galleryFiles": [
   {
    "full": "kit-emagrecimento.jpeg",
    "thumb": "kit-emagrecimento.jpeg"
   }
  ]
 },
 {
  "handle": "kit-renovacao-total",
  "slug": "kit-renovacao-total",
  "name": "Kit Renovação Total",
  "cat": "kit",
  "catLabel": "Detox · Suplementos · Cosméticos",
  "vol": "Pack completo",
  "rating": "4.8",
  "badges": [
   {
    "t": "Avançado",
    "cls": "best"
   }
  ],
  "bestseller": false,
  "bsRank": 99,
  "exp": true,
  "short": "O nosso pack mais completo: detox, suplementos e cosméticos que trabalham juntos para cuidar de si por dentro e por fora, em cada fase.",
  "blurb": "Rotina completa de renovação: detox, suplementos e cosméticos num só pack.",
  "d2": null,
  "d3": null,
  "imgFile": "kit-emagrecimento-depur.jpeg",
  "galleryFiles": [
   {
    "full": "kit-emagrecimento-depur.jpeg",
    "thumb": "kit-emagrecimento-depur.jpeg"
   }
  ]
 }
];
